import * as React from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';

function OverviewHeader(props) {
  const { demo } = props;

  return (
    <Paper
    square
      sx={{
        position: 'relative',
        backgroundColor: 'grey.800',
        color: '#fff',
        mb: 0,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundImage: `url(${demo.overviewImage})`,
      }}
    >
      {/* Increase the priority of the hero background image */}
      {<img style={{ display: 'none' }} src={`${process.env.PUBLIC_URL}${demo.overviewImage}`} alt={demo.imageText} />}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          bottom: 0,
          right: 0,
          left: 0,
          backgroundColor: 'rgba(0,0,0,.7)',
          background: 'linear-gradient(90deg, rgba(2,0,36,.8) 50%, rgba(0,212,255,0.03545168067226889) 100%)'
        }}
      />
      <Grid container>
        <Grid item md={8}>
          <Box
            sx={{
              position: 'relative',
              p: { xs: 3, md: 6 },
              pr: { md: 0 },
            }}
          >
            <Typography component="h1" variant="h3" color="inherit" gutterBottom>
              {demo.title}
            </Typography>
            <Typography variant="h5" color="inherit" paragraph>
              {demo.subtitle}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
}

export default OverviewHeader;